import { Link } from "react-router-dom";
import { Leaf, Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => (
  <footer className="bg-forest text-bone" data-testid="main-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-20 md:grid-cols-12 lg:px-10">
      <div className="md:col-span-5">
        <div className="flex items-center gap-2">
          <Leaf className="h-5 w-5 text-terra" strokeWidth={1.5} />
          <span className="font-serif text-2xl tracking-tight">Luca Mannu <span className="italic">Giardini</span></span>
        </div>
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-bone/60">
          Progettiamo, costruiamo e curiamo giardini in tutta la Sardegna.
          Ogni spazio verde racconta una storia: la tua.
        </p>
      </div>
      <div className="md:col-span-3">
        <p className="font-accent text-xs uppercase tracking-[0.25em] text-terra">Esplora</p>
        <div className="mt-5 flex flex-col gap-3 text-sm text-bone/80">
          <Link to="/blog" className="link-underline w-fit" data-testid="footer-blog">Blog</Link>
          <Link to="/negozio" className="link-underline w-fit" data-testid="footer-shop">Negozio</Link>
          <Link to="/attrezzi" className="link-underline w-fit" data-testid="footer-attrezzi">Attrezzi</Link>
          <Link to="/lavori" className="link-underline w-fit" data-testid="footer-works">Lavori</Link>
          <Link to="/contatti" className="link-underline w-fit" data-testid="footer-contact">Preventivi</Link>
        </div>
      </div>
      <div className="md:col-span-4">
        <p className="font-accent text-xs uppercase tracking-[0.25em] text-terra">Contatti</p>
        <div className="mt-5 flex flex-col gap-3 text-sm text-bone/80">
          <span className="flex items-center gap-3"><Phone className="h-4 w-4 text-terra" strokeWidth={1.5} /> +39 320 670 6410</span>
          <span className="flex items-center gap-3"><Mail className="h-4 w-4 text-terra" strokeWidth={1.5} /> info@lucamannugiardini.it</span>
          <span className="flex items-center gap-3"><MapPin className="h-4 w-4 text-terra" strokeWidth={1.5} /> Thiesi, Sardegna</span>
        </div>
      </div>
    </div>
    <div className="border-t border-bone/10">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-3 px-6 py-6 text-xs text-bone/40 md:flex-row md:items-center lg:px-10">
        <p>© {new Date().getFullYear()} Luca Mannu Giardini. Tutti i diritti riservati.</p>
        <Link to="/admin" className="link-underline font-accent uppercase tracking-[0.2em]" data-testid="footer-admin-link">Area riservata</Link>
      </div>
    </div>
  </footer>
);
